import type { EnterApiConfig } from '../config';
import { createBaseHttp } from './base-http';
import type { EnterHttpClient } from './types';

/**
 * no-auth 表示不获取默认 Auth0 用户 token，也不因 401 触发登录。
 * 调用方仍然可以在请求头中显式传入 service 或 public-thread bearer token。
 */
export function createNoAuthHttp(baseHttp: EnterHttpClient): EnterHttpClient {
    return baseHttp;
}

/** `@enter/auth` 在 Auth0 会话建立前创建 Risk Session 时使用的 bootstrap 入口。 */
export function createNoAuthHttpClient(config: EnterApiConfig): EnterHttpClient {
    return createNoAuthHttp(createBaseHttp(config));
}

export { EnterHttpError } from './errors';
export { parseRetryAfterMs } from './retry-after';
export type { ExtraHeaders, MaybePromise } from '../config';
